<template>
  <div class="page-container1 content-430">
    <div class="header-wrapper-430">
      <Form
        ref="searchForm"
        label-position="right"
        :label-width="0"
        class="search-list-430 search-wrapper-430"
        style="margin-bottom: 16px"
      >
        <Row class="relative" type="flex" flex="end">
          <FormItem label="">
            <Select
              v-model="searchConds.orgKind"
              placeholder="单位类别"
              clearable
              filterable
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in orgKindList"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Cascader
              v-model="searchConds.area"
              placeholder="所属行政区"
              :data="regionDataList"
              @on-change="handelAreaChange"
            ></Cascader>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="searchConds.coSts"
              placeholder="合作状态"
              clearable
              filterable
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in cooperationList"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="searchConds.infoSts"
              placeholder="信息完善状态"
              clearable
              filterable
              class="search-select-430"
            >
              <Option
                v-for="(item, index) in completeStatusList"
                :key="index"
                :value="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="">
            <Input
              v-model.trim="searchConds.searchStr"
              class="longInput-430"
              placeholder="单位全称/简称/组织机构代码/联系人姓名/手机号"
              clearable
            ></Input>
          </FormItem>
          <Button type="primary" @click="handleSearch">确定</Button>
          <Button class="search-430" @click="handleReset">重置</Button>
        </Row>
      </Form>
    </div>
    <div v-if="userInfo.userType === 5" class="table-title-430">
      <!-- v1.3.1仅限超管账号有此功能，子账号没有 -->
      <div class="operation-430">
        <Button
          v-if="userInfo.userType === 5"
          type="primary"
          @click="handelAddStuModalShow"
        >自关课程服务</Button>
        <Button
          v-if="userInfo.userType === 5"
          type="primary"
          class="search-430"
          @click="handelrelieveModalShow"
        >解除服务合作</Button>
      </div>
    </div>

    <div class="table">
      <Table
        ref="selection"
        border
        :columns="tableColumns"
        :data="tableData"
        :max-height="tableHeight"
        @on-selection-change="tableSelect"
      >
        <template slot="action" slot-scope="{ row }">
          <span
            class="operate-btn-430"
            @click="handleToDetail(row)"
          >查看详情</span>
        </template>
      </Table>
    </div>
    <div class="paging">
      <Page
        :total="pageInfo.total"
        show-total
        show-elevator
        :current="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        @on-change="handlePageChange"
      ></Page>
    </div>
    <Modal
      v-model="addStuModalShow"
      :mask-closable="false"
      title="自关联培训服务添加"
      width="800"
    >
      <div class="relation-model-section">
        <div class="relation-model-top">
          <div class="left-box">
            提示：以下是入围的服务校区，学校可添加对应服务与学校合作。
          </div>
          <div class="right-box">
            <div class="form-li">
              <div class="label">服务名称：</div>
              <div class="value">
                <Input
                  v-model="searchConds.orgName1"
                  placeholder="请输入服务名称"
                  style="width: 200px"
                  clearable
                ></Input>
              </div>
              <Button type="primary" @click="handleSearch1">确定</Button>
            </div>
          </div>
        </div>
        <div class="relation-model-form">
          <Table
            ref="relation"
            border
            :columns="relationColumns"
            :data="relationData"
            @on-selection-change="relationTableSelect"
          ></Table>
          <div class="paging">
            <Page
              :current="relationPage.pageNum"
              :total="relationPage.total"
              show-total
              show-elevator
              size="small"
              @on-change="relationPageChange"
            ></Page>
          </div>
        </div>
        <div class="relation-model-bottom">
          <div class="tit">学校已合作服务校区名单</div>
          <div class="main">
            <div
              v-for="(item, index) in associatedOrgList"
              :key="item.orgId + index"
              class="box"
            >
              {{ item.orgName }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button
          style="margin-right: 20px"
          @click="addStuModalShowCancel"
        >取消</Button>
        <Button type="primary" @click="addStuModalShowOk">确定</Button>
      </div>
    </Modal>
    <Modal
      v-model="relieveModalShow"
      :mask-closable="false"
      title="解除服务合作"
    >
      <div class="relieveModal-main">
        <div class="form-ul">
          <div class="form-li">
            <div class="label"><span>*</span>与学校的状态：</div>
            <div class="value">
              <Select
                v-model="removeOrgParams.sts"
                placeholder="请选择教师角色"
                style="width: 200px"
              >
                <Option value="2">解除关系</Option>
              </Select>
            </div>
          </div>
          <div class="form-li">
            <div class="label"><span>*</span>原因：</div>
            <div class="value">
              <Input
                v-model="removeOrgParams.remark"
                placeholder="请输入"
                style="width: 200px"
                clearable
              ></Input>
            </div>
          </div>
          <div class="form-li">
            <div class="label"><span>*</span>当前账号登录密码：</div>
            <div class="value">
              <Input
                v-model="removeOrgParams.pwd"
                placeholder="请输入"
                type="password"
                style="width: 200px"
                clearable
              ></Input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button
          style="margin-right: 20px"
          @click="relieveModalShowCancel"
        >取消</Button>
        <Button type="primary" @click="relieveModalShowOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { regionDataList } from '@/utils/dictionary';
import schoolAdmin from '@/request/schoolAdmin/index.js';
import operationAdmin from '@/request/operationAdmin/index.js';
import { opeEduListColumns } from '@/pages/assetsModules/manageData.js';
import { orgKindList, cooperationList, completeStatusList } from '@/utils/dictionary.js';
import EditButton from '@/pages/assetsModules/EditButton';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  name: 'ResourceEducationMage',
  components: { EditButton },
  filters: {
    InitCooperateState(v) {
      switch (v) {
        case 1:
          return '正常';
        case 2:
          return '已停止合作';
      }
    }
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      regionDataList: [],
      pageInfo: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      searchConds: {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        area: [],
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        coSts: null, // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
        reviewState: null // 教育局审批状态 0：未审批 1：通过 2：不通过 当前用户是超管时这个筛选条件才会生效
      },
      tableColumns: [...opeEduListColumns],
      orgKindList, // 单位类别列表
      cooperationList, // 合作状态列表
      completeStatusList, // 信息完善状态
      tableData: [],
      addStuModalShow: false, // 关联弹窗
      relationColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '服务名称',
          key: 'name',
          align: 'center'
        }
      ],
      relationData: [],
      associatedOrgList: [],
      relieveModalShow: false,
      removeOrgParams: {
        schoolOrgRelId: '',
        remark: '',
        sts: '2',
        pwd: ''
      },
      activeSelection: [],
      relationPage: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }

    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['routeTitle'])
  },
  created() {
    this.regionDataList = [...regionDataList];
    this.getOrgList();
    this.tableColumns.unshift({
      type: 'selection',
      width: 60,
      align: 'center',
      fixed: 'left'
    });
    if (this.userInfo.userType === 5) {
      this.tableColumns.push({
        title: '与学校合作状态',
        key: 'sts',
        minWidth: 180,
        align: 'center',
        render: (h, params) => {
          return h('div', {
            class: {
              'pass-status-430': params.row.sts === 1,
              'stop-status-430': params.row.sts === 2
            }
          }, [params.row.sts === 1 ? '合作' : params.row.sts === 2 ? '未合作' : '']);
        }
      });
    }
  },
  methods: {
    // 地区选择
    handelAreaChange(value, selectedData) {
      this.searchConds.area = value;
      this.searchConds.areaCode = value[value.length - 1];
    },
    // 重置
    handleReset() {
      this.searchConds = {
        searchStr: null, //  搜索关键词 单位全称、简称、组织机构代码、联系人姓名、手机号等
        orgKind: null, // 单位类别 1：正式号 2：测试号 3：体验号
        areaCode: null, // 所属行政区
        infoSts: null, // 信息完善状态 0：待完善 1：信息完善
        coSts: null, // 单位合作状态 0：默认 1：合作 2：洽谈中 3：终止合作
        reviewState: null // 教育局审批状态 0：未审批 1：通过 2：不通过 当前用户是超管时这个筛选条件才会生效
      };
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getOrgList();
    },
    // 分页
    handlePageChange(v) {
      this.pageInfo.pageNum = v;
      this.getOrgList();
    },
    // 服务机构详情
    handleToDetail(row, index) {
      this.$router.push({
        name: 'basicInfoCenter_schOrganService_organ_organDetails',
        query: { orgId: row.orgId }
      });
    },
    // 查询服务机构列表
    async getOrgList() {
      const { total, ...pageInfo } = this.pageInfo;
      const { area, ...searchConds } = this.searchConds;
      const params = { ...pageInfo, ...searchConds, schoolId: this.userInfo.orgId };
      const res = await schoolAdmin.getSchoolOrgList(params);

      if (res.status === 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    },
    // 关联系列弹窗
    handelAddStuModalShow() {
      this.searchConds.orgName1 = '';
      this.addStuModalShow = true;
      this.getAssociatedOrgFunc();
      this.getSchoolAssociatedOrgFunc();
    },
    relationTableSelect(selection) {
      console.log(selection, '选择的---');
      this.activeRelation = selection;
    },
    relationPageChange(current) {
      this.relationPage.pageNum = current;
      this.getAssociatedOrgFunc();
    },
    handleSearch1() {
      this.getAssociatedOrgFunc();
    },
    // 学校自关联服务分页列表
    async getAssociatedOrgFunc() {
      const params = {
        schoolId: this.userInfo.orgId,
        pageNum: this.relationPage.pageNum,
        pageSize: this.relationPage.pageSize,
        orgName: this.searchConds.orgName1
      };
      const res = await operationAdmin.getAssociatedOrgNew(params);
      if (res.status === 200) {
        this.relationPage.total = Number(res.message.total);
        this.relationData = res.message.list;
      }
    },
    // 学校已关联服务
    async getSchoolAssociatedOrgFunc() {
      const params = {
        schoolId: this.userInfo.orgId
      };
      const res = await operationAdmin.getSchoolAssociatedOrgNew(params);
      if (res.status === 200) {
        this.associatedOrgList = res.message;
      }
    },
    // 学校关联服务提交
    async postAssociatedOrgBySchoolFunc(ids) {
      const params = {
        schoolId: this.userInfo.orgId,
        orgMode: '1',
        orgIds: ids
      };
      const res = await this.$http.postAssociatedOrgBySchool(params);
      if (res.status === 200) {
        this.$Message.success('关联成功');
        this.pageInfo.pageNum = 1;
        this.getOrgList();
      }
    },
    relieveModalShowCancel() {
      this.relieveModalShow = false;
    },
    relieveModalShowOk() {
      if (!this.removeOrgParams.remark) {
        this.$Message.warning('请填写原因');
        return;
      }
      if (!this.removeOrgParams.pwd) {
        this.$Message.warning('请填写密码');
        return;
      }
      // console.log(this.removeOrgParams)
      this.putRemoveOrgBySchoolFunc();
    },
    // 解除系列弹窗
    handelrelieveModalShow() {
      if (this.activeSelection.length > 1) {
        this.$Message.warning('只能选择一个服务！');
        return;
      }
      if (this.activeSelection.length < 1) {
        this.$Message.warning('请选择一个服务！');
        return;
      }
      this.removeOrgParams.remark = '';
      this.removeOrgParams.pwd = '';
      console.log(this.activeSelection);
      this.removeOrgParams.schoolOrgRelId = this.activeSelection[0].relId;
      console.log(this.activeSelection, '是撒谎----');
      this.relieveModalShow = true;
    },
    // 解除服务合作
    async putRemoveOrgBySchoolFunc() {
      const params = {
        schoolOrgRelId: this.removeOrgParams.schoolOrgRelId,
        cancelReason: this.removeOrgParams.remark,
        sts: this.removeOrgParams.sts,
        pwd: this.removeOrgParams.pwd
      };
      const res = await operationAdmin.putRemoveOrgBySchoolNew(params);
      if (res.status === 200) {
        this.$Message.success('解除成功');
        this.relieveModalShow = false;
        this.activeSelection = [];
        this.getOrgList();
      }
    },
    // 选择列表项
    tableSelect(selection) {
      this.activeSelection = selection;
    },
    addStuModalShowCancel() {
      this.addStuModalShow = false;
    },
    addStuModalShowOk() {
      if (this.activeRelation.length < 1) {
        this.$Message.warning('请最少选择一个服务！');
        return;
      }
      const ids = [];
      this.activeRelation.map(item => {
        ids.push(item.orgId);
      });
      this.postAssociatedOrgBySchoolFunc(ids);
      this.addStuModalShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
.page-container1 {
  height: 100%;
  box-sizing: border-box;
  .green {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: green;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
  .purple {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: purple;
    margin-right: 5px;
    border-radius: 5px;
    margin-bottom: 2px;
  }
}
.col-center {
  padding: 0 8px;
  margin-bottom: 8px;
  button + button {
    margin-left: 16px;
  }
}
.tabs-block {
  display: flex;
  margin: 8px 0 24px 0;
  border-bottom: 1px solid #ccc;
  .tab-item {
    padding: 16px 32px;
    border-bottom: 2px solid transparent;
    font-size: 16px;
  }
  .tab-item-active {
    color: #488ffa;
    border-bottom: 2px solid #488ffa;
  }
  .tab-item + .tab-item {
    margin-left: 16px;
  }
}
.relation-model-section {
  width: 100%;
  .relation-model-top {
    width: 100%;
    display: flex;
    .form-li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .label {
        font-size: 14px;
        width: 120px;
        text-align: right;
        span {
          color: red;
        }
      }
      .value {
        margin-right: 20px;
      }
    }
  }
  .relation-model-form {
    width: 100%;
  }
  .relation-model-bottom {
    width: 100%;
    .tit {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    .main {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .box {
        width: 29%;
        margin-right: 4%;
        line-height: 40px;
        border: 1px solid #eee;
        text-align: center;
        border-radius: 7px;
        margin-bottom: 15px;
      }
      .box:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
.relieveModal-main {
  width: 100%;
  .form-ul {
    width: 100%;
    .form-li {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .label {
        font-size: 14px;
        width: 160px;
        text-align: right;
        span {
          color: red;
        }
      }
    }
  }
  .form-btn {
    padding-top: 100px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
